<div
  class="payment-mode-hints"
  [class.-compact]="compact()">
  <div
    class="d-flex align-items-center mb-3"
    [attr.data-e2e]="elementsSelector.name.calendarRow">
    <div class="hint-icon hint-icon-calendar d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle mr-3">
      <i class="fa fa-calendar"></i>
    </div>
    <span>
      @if (isYearlyLicenseMode()) {
        {{ 'shared:paymentModeHints.annualSubscription' | i18next }}
      } @else {
        {{ 'shared:paymentModeHints.monthlySubscription' | i18next }}
      }
    </span>
  </div>

  <div
    class="d-flex align-items-center mb-3"
    [attr.data-e2e]="elementsSelector.name.creditCardRow">
    <div class="hint-icon hint-icon-credit-card d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle mr-3">
      <i class="fa fa-credit-card"></i>
    </div>
    <span>
      @if (isYearlyLicenseMode()) {
        {{ 'shared:paymentModeHints.postpaymentAnnual' | i18next }}
      } @else {
        {{ 'shared:paymentModeHints.postpaymentMonthly' | i18next }}
      }
    </span>
  </div>

  <div
    class="d-flex align-items-center"
    [attr.data-e2e]="elementsSelector.name.keyRow">
    <div class="hint-icon hint-icon-key d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle mr-3">
      <span class="ico ico-Key"></span>
    </div>
    <span>{{ 'shared:paymentModeHints.noNeedToBuy' | i18next }}</span>
  </div>

  <div class="hint-content"><ng-content /></div>
</div>
